import Section from "../../components/Section/Section";

export default function Welcome() {
  return <Section>Bienvenue.</Section>;
}
